import { createApp } from 'vue'
import __t from "../../helpers/translate";
import vue_helpers from "../../helpers/check_null";
import {createBootstrap} from 'bootstrap-vue-next';
import imc_toast from "./toast/imc_toast.vue";
import confirm from "./confirm/confirm.vue";

window.IMC_APP = createApp({
       name : "IMC_APP",
       id : "IMC_APP",
       components : {
           imc_toast : imc_toast,
           confirm :confirm,
       }
    })
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(v_store)
    .mount('#imc_app');
